import { createContext, useContext, useSyncExternalStore, type ReactNode } from 'react';
import type { SessionState, SessionStore } from './store.js';

const StoreContext = createContext<SessionStore | null>(null);

export function SessionProvider({ store, children }: { store: SessionStore; children: ReactNode }) {
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}

export function useSessionStore(): SessionStore {
  const store = useContext(StoreContext);
  if (store === null) throw new Error('useSessionStore вызван вне SessionProvider');
  return store;
}

export function useSession(): SessionState {
  const store = useSessionStore();
  return useSyncExternalStore(store.subscribe, store.snapshot);
}
